import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useStore } from '@nuxtjs/composition-api';
import { AppMenu } from 'store/menus';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopbarLocation',
  setup(__props) {

const store = useStore();
const menuTop: AppMenu = store.getters['menus/menuTop'];

const options = computed(() =>
  menuTop.map((el) => ({
    name: el.name,
    value: el.url,
  })),
);
const currentPage = computed(() => {
  if (!process.client) return '';
  return options.value.find((option) => option.value === window.location.origin)
    ?.value;
});

const handleSelect = (e: any) => {
  window.location.replace(e);
};

return { __sfc: true,store, menuTop, options, currentPage, handleSelect }
}

})